export default __webpack_public_path__ + "static/media/logo512.985bd4fd.png";